import { cn } from '@tripleten/cn';

export const cnCheckboxWrapper = cn('kc-checkbox-wrapper');
